import { Component, Input } from '@angular/core';
import { LookUpResourceModel } from 'src/app/section-wise/models/lookup-resource.model';

@Component({
  selector: 'insurance-policy-detail-sw, [insurancePolicyDetailSw]',
  templateUrl: './insurance-policy-detail-sw.component.html'
})
export class InsurancePolicyDetailSwComponent {
  isActive = false;
  @Input() insurancePolicyDetail: Array<LookUpResourceModel>;

  constructor() {}

  toggleActive(): void {
    this.isActive = !this.isActive;
  }
}
